import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'analysis/affinity',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const BubbleChart = require('./containers/Campaign').default
      const bubbleChartReducer = require('components/BubbleChart/reducers').default;

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })
      injectReducer(store, { key: 'bubbleData', reducer: bubbleChartReducer });
      /*  Return getComponent   */
      cb(null, BubbleChart)

    /* Webpack named bundle   */
    }, 'campaign')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Analysis/index.js